<div class="user-name" *ngIf="show">
    <div class="container">
        <span aria-level="1" role="heading" class="name">היי <span>{{name}}</span></span>
        <span class="last-time-date">הפעם הקודמת שהתראינו היתה ב: <span>{{lastLoginDate}}</span></span>
    </div>
</div>
